import VPopover from './index.vue';

export default {
  install: (Vue) => Vue.component('VPopover', VPopover),
};
